<template>
	<div :class="($route.path === '/checkout')?'col-12 p-0':'col p-0'">
		<form data-vv-scope="internalBankCard" @submit.prevent="action('internalBankCard')">
			<div class="form-group mt-3 width-reduce-large-device">
				<label for="bank-card-payment-method-account-chooser" id="internal-bank-card-pay-heading">
					Choose Your Card
					<span class="asteriskField">*</span>
				</label>
				<select
					@change="$forceUpdate()"
					class="custom-select d-block w-100"
					id="bank-card-payment-method-account-chooser"
					name="bankCardPaymentAccountChooser"
					v-validate="{ required: true }"
					v-model="selectedCard"
					:class="((showInternalCardSelectionError && selectedCard === 'Select...') || errors.has('internalBankCard.bankCardPaymentAccountChooser'))?'is-invalid':''"
				>
					<option disabled>Select...</option>
					<option
						v-for="(cardNumber,index) in this.getUserData.card_numbers"
						:key="index"
						:id="'country'+index"
					>
						{{cardNumber}}
					</option>
				</select>
				<div
					class="invalid-feedback"
					v-if="((showInternalCardSelectionError && selectedCard === 'Select...') || errors.has('internalBankCard.bankCardPaymentAccountChooser'))"
					id="internalBankAccount-select-error"
				>Please select an account to proceed</div>
			</div>
			<button
				id="bank-internal-card-payment-proceed-button"
				class="btn btn-primary blue-btn mx-auto"
				type="submit"
				data-test="bankCardPayBtn"
			>
				Proceed to Pay
			</button>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { store } from '../../../../store/store'
import { orderApi } from '../../../../services/ApiServices/orderApi'
export default {
	name: 'bank-internal-card',
	computed: {
		...mapGetters('user', ['getUserData'])
	},
	data () {
		return {
			selectedCard: 'Select...',
			showInternalCardSelectionError: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result && this.selectedCard !== 'Select...') {
					this.showInternalCardSelectionError = false
					this.internalBankPay()
				} else {
					this.showInternalCardSelectionError = true
				}
			})
		},
		internalBankPay () {
			this.$dialog
				.confirm('Please confirm to pay using Your Card')
				.then((dialog) => {
					orderApi.orderCharge('INT_CARD', this.selectedCard).then(() => {
						this.$router.push({
							path: '/order-success',
							query: {
								order_number: store.getters['user/getOrderData'].order_number,
								payment_mode: 'card'
							}
						})
					})
				})
				.catch(() => {
					// console.log('Clicked on cancel')
				})
		}
	},
	props: {
		gatewayId: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped>

</style>
